// extracted by mini-css-extract-plugin
module.exports = {"section4":"styles_section4__24o9m","title":"styles_title__3dDSJ"};